import { CMSMenuViewModel } from './cms-menu-view-model/cms-menu.viewModel';

import type { ICMSLayoutViewModel } from './cms-layout.viewModel.types';
import type { CMSLayout } from '@/src/cms/domain/models/cms-layout';


export class CMSLayoutViewModel implements ICMSLayoutViewModel {
  readonly main: ICMSLayoutViewModel['main'];

  readonly footer: ICMSLayoutViewModel['main'];

  readonly legal: ICMSLayoutViewModel['main'];

  constructor(data: ICMSLayoutViewModel) {
    if (data.main) this.main = new CMSMenuViewModel(data.main);
    if (data.footer) this.footer = new CMSMenuViewModel(data.footer);
    if (data.legal) this.legal = new CMSMenuViewModel(data.legal);
  }

  static presenter(entity: CMSLayout): CMSLayoutViewModel {
    return new CMSLayoutViewModel({
      main: entity.main ? CMSMenuViewModel.presenter(entity.main) : undefined,
      footer: entity.footer
        ? CMSMenuViewModel.presenter(entity.footer)
        : undefined,
      legal: entity.footer ? CMSMenuViewModel.presenter(entity.footer) : undefined
    });
  }
}
